import React from 'react';
import PropTypes from 'prop-types';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faGripVertical } from '@fortawesome/free-solid-svg-icons';

const propTypes = {
    item: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    onDelete: PropTypes.func,
    onColorChange: PropTypes.func,
    dragDisabled: PropTypes.bool,
};

const defaultProps = {
    onDelete: () => { },
    onColorChange: () => { },
    dragDisabled: false,
};

const EmergencyRouteItem = (props) => {
    const { item, index, onDelete, onColorChange, dragDisabled } = props;

    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({
        id: item.id || `route-${index}`,
        disabled: dragDisabled,
    });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
    };

    return (
        <>
            <div
                ref={setNodeRef}
                style={style}
                className={`emergency_route_list_item ${isDragging ? 'dragging' : ''}`}
            >
                <div
                    className="emergency_route_list_drag_handle"
                    {...attributes}
                    {...listeners}
                >
                    <FontAwesomeIcon icon={faGripVertical} />
                </div>
                <div className="emergency_route_list_filename_cell">
                    <label>{item.fileName}</label>
                </div>
                <div className="emergency_route_list_routename_cell">
                    <label>{item.routeName}</label>
                </div>
                <div className="emergency_route_list_order_cell">
                    <label>{item.displayOrder}</label>
                </div>
                <div className="emergency_route_list_color_cell">
                    <input
                        className='emergency_route_color_box'
                        type="color"
                        value={item.color}
                        onChange={(e) => onColorChange(index, e.target.value)}
                    />
                </div>
                <div
                    className="emergency_route_list_action_cell"
                    onClick={() => onDelete(item, index)}
                >
                    <FontAwesomeIcon icon={faTrash} />
                </div>
            </div>
            <div className="emergency_route_list_separator" />
        </>
    );
};

EmergencyRouteItem.propTypes = propTypes;
EmergencyRouteItem.defaultProps = defaultProps;
export default EmergencyRouteItem;
